"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailPadOptions = void 0;
exports.emailPadOptions = [
    {
        label: "@gmail.com",
        value: "@gmail.com"
    },
    {
        label: "@outlook.com",
        value: "@outlook.com"
    },
    {
        label: "@yahoo.com",
        value: "@yahoo.com"
    }
];
//# sourceMappingURL=emailPadOptions.js.map